import { render, staticRenderFns } from "./dialog-signup-detail.vue?vue&type=template&id=97991cf6&scoped=true"
import script from "./dialog-signup-detail.vue?vue&type=script&lang=js"
export * from "./dialog-signup-detail.vue?vue&type=script&lang=js"
import style0 from "./dialog-signup-detail.vue?vue&type=style&index=0&id=97991cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97991cf6",
  null
  
)

export default component.exports